import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { error, isEmpty} from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import forms from "../../common/forms";
import { openSnackbar, snackbarModel } from "../../common/snackbar";

const props = {
    //MARKERS
    adminOrderNotesMarker: '.marker-order-notes',

    modalPlaceholder: '#popup-placeholder',
    orderId: '#order-id',
    existingNotesWrapper: '#notes-existing-wrapper',
    addNewNote: '#add-new-note',
    newNoteModal: '#add-new-note-modal',
    newNoteModalId: 'add-new-note-modal', 
    newNoteForm: '#new-note-form',
    saveNewNote: '#save-new-note'
};

export function initAdminOrderNotes() {

    if ($(props.adminOrderNotesMarker).length) {

        loadExistingNotes();   
    }
}

async function loadExistingNotes() {

    const orderId = $(props.orderId).val();

    const data = {
        parentId: orderId,
        parentType: 'ORDER'
    };

    const result = await getExistingNotesService(data);

    await injectHtml(props.existingNotesWrapper, result);

    setTimeout(function () {
        initDisplayAddNewNoteModalEvents();
    }, 100);
}


async function initDisplayAddNewNoteModalEvents() {

    catchError(async function () {

        $(props.addNewNote).off('click').on('click', async function () {
            initAddNewNoteDisplayModal();
        });

    });
}

async function initAddNewNoteDisplayModal() {

    const orderId = $(props.orderId).val();

    const data = {
        notesParentId: orderId,
        noteEntityTypeId: 1,
        notesParentDescription: 'Order'
    };

    const result = await getAddNewNoteModalHtml(data);

    await injectHtml(props.modalPlaceholder, result);

    //bind 'modal on shown' events
    await initAddNewNoteDisplayModalOnShow();

    //launch modal
    $(props.newNoteModal).modal('show');
}


function initAddNewNoteDisplayModalOnShow() {

    catchError(async function () {

        //when the modal is shown bind all relevant events
        $(props.newNoteModal).off('shown.bs.modal').on('shown.bs.modal', async function (e) {

            //init standard mdc elements
            window.mdc.autoInit(document.getElementById(props.newNoteModalId));

            //bind submit event
            initSubmitNoteEvents();

            $('#Content').focus();
        })
    });
}


async function initSubmitNoteEvents() {

    catchError(async function () {

        const formObject = $(props.newNoteForm);

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(props.saveNewNote).off('click').on('click', async function () {

                forms.addRequiredRule($('#Content'));

                //validate form
                if (formObject.valid()) {

                    const parent = $(props.newNoteModal);

                    const activityIndicator = parent.find('.modal-activity-indicator');

                    activityIndicator.show().css("display", "inline-block");

                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        const formValues = formObject.serialize();

                        //attempt POST save, the check response
                        const response = await addNewNoteService(formValues);

                        if (response.responseType === "SUCCESS") { 

                            $(props.newNoteModal).modal('hide');

                            loadExistingNotes();

                            //display confirmation message to the user
                            openSnackbar({
                                ...snackbarModel,
                                content: 'Note added.'
                            });
                        }
                        else {

                        }

                        forms.formUnderSubmission(false);

                    }, 1000);
                } else {

                    //no scroll to in modal
                    //app.forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}


//API CALLS

async function getExistingNotesService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/notes/existingnotes', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}


async function getAddNewNoteModalHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/notes/buildaddnewnotemodal', data);

    // The response is an object with a property called 'data'. This contains the modal HTML.
    return response.data;
}


async function addNewNoteService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/notes/savenote', data);

    return response.data;
}